module.exports = __webpack_public_path__ + "static/media/animated_logo.fdba91c3.svg";